import { jsonFetch } from "@/lib/helpers";
import { Task } from "@/models/task";
import { TASKS_URL } from "./api-url.constants";
import { TaskApiDTO } from "./dtos";
import { mapTaskDTOToTask } from "./mappers";

export interface GetTaskByIdResponse {
  data: TaskApiDTO;
}

export const getTaskById = async (taskId: string): Promise<Task> => {
  const response = await jsonFetch<GetTaskByIdResponse>(`${TASKS_URL}/${taskId}`);
  return mapTaskDTOToTask(response.data);
};
